$ {
  const {
    trait,
    localizedContent
  } = input;
  const label = trait && trait.name ? `${trait.name}:` : null;
  const componentName = 'trait-selector';
  const outOfStockText = localizedContent?.outOfStock || 'Out of stock';
  const errorText = localizedContent?.errorText || 'Select';
}
<div class=[componentName]>
  <ebay-listbox-button prefixLabel=label on-change("handleChange") fluid hasError=state.errorMessage>
    <@option value="-1" text="--" selected=('-1' === state.selected)/>
    <if(component.filteredValues)>
      <for|value| of=component.filteredValues>
        $ {
          const {
            name
          } = value;
          const isOutOfStock = component.isOutOfStock(value);
          const suffix = isOutOfStock ? `(${outOfStockText})` : '';
        }
        <@option value=name text=`${name} ${suffix}` selected=(name === state.selected) disabled=isOutOfStock/>
      </for>
    </if>
  </ebay-listbox-button>
  <div class=['error-text', state.errorMessage ? 'error-enabled' : ''] hidden=!state.errorMessage>
    <ebay-attention-filled-16-icon/>
    <span>
      ${errorText} ${trait?.name}
    </span>
  </div>
</div>